/**
 * @generated SignedSource<<5b7dc925798f0e1a955da69f0b805b7a>>
 * @relayHash 7aa392ac24b60ca30af878bca1c734bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7732d40cfe8a07c6480c6fa88698f2b50d6f208bd2caeb687fa3bafbe1f452fd

import type { ConcreteRequest } from 'relay-runtime';
export type CommentDeletionLocation = "EDITOR" | "LIVE" | "%future added value";
export type CommentDeleteGeneralCommentMutation$variables = {
  commentIdToDelete: string;
  deleteFrom?: CommentDeletionLocation | null | undefined;
};
export type CommentDeleteGeneralCommentMutation$data = {
  readonly deleteComment: boolean | null | undefined;
};
export type CommentDeleteGeneralCommentMutation = {
  response: CommentDeleteGeneralCommentMutation$data;
  variables: CommentDeleteGeneralCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentIdToDelete"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deleteFrom"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "commentIdToDelete",
        "variableName": "commentIdToDelete"
      },
      {
        "kind": "Variable",
        "name": "deleteFrom",
        "variableName": "deleteFrom"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteComment"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CommentDeleteGeneralCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentDeleteGeneralCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7aa392ac24b60ca30af878bca1c734bb",
    "id": "7732d40cfe8a07c6480c6fa88698f2b50d6f208bd2caeb687fa3bafbe1f452fd",
    "metadata": {},
    "name": "CommentDeleteGeneralCommentMutation",
    "operationKind": "mutation",
    "text": "mutation CommentDeleteGeneralCommentMutation($commentIdToDelete:ID!,$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete,deleteFrom:$deleteFrom)}"
  }
};
})();

(node as any).hash = "21ca12d96d4a730277a95bbc05c15c9c";

export default node;
